import React from "react";
import { Rocket, Radio } from "lucide-react";

export const Navbar = ({ shuffleLabel, onNav }) => {
  const links = [
    ["how", "How It Works"],
    ["community", "Community"],
    ["trending", "Vote"],
  ];
  return (
    <nav
      data-testid="navbar"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#05070b]/80 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <button
          data-testid="logo-button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2 group"
        >
          <span className="grid place-items-center h-9 w-9 rounded-lg bg-gradient-to-br from-[#00ff66] to-[#00f0ff] text-black">
            <Rocket size={18} strokeWidth={2.6} />
          </span>
          <span className="font-display font-black text-xl tracking-tighter">
            SEND<span className="neon-underline">IT</span>
          </span>
        </button>

        <div className="hidden md:flex items-center gap-1">
          {links.map(([id, label]) => (
            <button
              key={id}
              data-testid={`nav-${id}`}
              onClick={() => onNav(id)}
              className="px-4 py-2 text-sm font-semibold text-slate-300 hover:text-white hover:bg-white/5 rounded-lg transition-colors"
            >
              {label}
            </button>
          ))}
        </div>

        <div
          data-testid="shuffle-mini"
          className="flex items-center gap-2 rounded-full border border-emerald-500/30 bg-emerald-500/10 pl-3 pr-4 py-1.5"
        >
          <span className="relative flex h-2.5 w-2.5">
            <span className="ping-ring absolute inline-flex h-full w-full rounded-full bg-emerald-400" />
            <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-400" />
          </span>
          <Radio size={13} className="text-emerald-400 hidden sm:block" />
          <span className="font-mono-num text-xs font-bold text-emerald-300 tracking-wider">
            {shuffleLabel}
          </span>
        </div>
      </div>
    </nav>
  );
};
